<template>
<div
  class="calc"
  :style="{'--selected-game-color': color}"
>
  <h3 class="calc_heading">{{ $c('Калькулятор ежемесячного голдбека') }}</h3>
  <p>{{ $c('Выберите игру для которой вы хотите рассчитать ежемесячный голдбек.') }}</p>
  <ul class="calc_games">
    <li
      v-for="(game, index) in GAMES_LIST"
      v-bind:key="index"
      :class="['calc_games-item', {'calc_games-item__active': game === currentGame}]"
      @click="selectGame(game)"
    >
      <img :src="getGameImgUrl(game)" alt="" />
    </li>
  </ul>
  <p>{{ $c('Введите суму предполагаемого ежемесячного оборота по карте в рублях или задайте желаемый обьем голдбека.') }}</p>
  <div class="calc_inputs">
    <ExtraBonusCalcInput
      :money.sync="realMoney"
      @update:money="updateRealMoney"
    >
      <template v-slot:units>{{$c('руб./мес.')}}</template>
    </ExtraBonusCalcInput>
    <div class="calc_input-div" />
    <ExtraBonusCalcInput
      :money.sync="gameMoney"
      :styled="true"
      @update:money="updateGameMoney"
    >
      <template v-slot:units>
        <GameIcon :game="currentGame" />
      </template>
    </ExtraBonusCalcInput>
  </div>
  <div class="calc_slider-place">
    <VueSlider
      ref="slider"
      v-model="realMoneySlider"
      :min="1"
      :max="500000"
      :dot-size="24"
      :interval="1"
      @change="updateSliderRealMoney"
    ></VueSlider>
  </div>
</div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import VueSlider from 'vue-slider-component'
import ExtraBonusCalcInput from '@/components/ExtraBonus/ExtraBonusCalcInput'
import { GAME_TO_COLORS, GAMES } from '@/constants'
import GameIcon from './GameIcon'

@Component({
  components: {
    VueSlider,
    ExtraBonusCalcInput,
    GameIcon
  }
})
class ExtraBonusCalc extends Vue {
  @Prop({
    type: String,
    default: GAMES.TB,
    key: 'game'
  }) cardGame

  @Prop({
    type: Object,
    default: {
      [GAMES.MT]: 0,
      [GAMES.TB]: 0,
      [GAMES.MK]: 0
    }
  }) goldRate

  GAMES = GAMES

  GAMES_LIST = [
    GAMES.TB,
    GAMES.MK,
    GAMES.MT
  ]

  selectedGame = null
  realMoney = 10000
  realMoneySlider = this.realMoney
  gameMoney = 667

  get currentGame () {
    if (this.selectedGame) return this.selectedGame
    return this.cardGame
  }

  get color () {
    return GAME_TO_COLORS[this.currentGame]
  }

  get goldRateForGame () {
    return this.goldRate[this.currentGame]
  }

  getGameImgUrl (game) {
    return require('@/components/GameSwitcher/img/' + game + '.svg')
  }

  selectGame (game) {
    this.selectedGame = game
    this.gameMoney = Math.ceil(this.realMoney * this.goldRateForGame)
  }

  updateRealMoney (val) {
    this.gameMoney = Math.ceil(val * this.goldRateForGame)
    this.realMoneySlider = Math.min(999999999999, this.realMoney)
  }

  updateGameMoney (val) {
    this.realMoney = Math.ceil(val / this.goldRateForGame)
    this.realMoneySlider = Math.min(999999999999, this.realMoney)
  }

  updateSliderRealMoney (val) {
    this.realMoney = val
    this.gameMoney = Math.ceil(val * this.goldRateForGame)
  }

  mounted () {
    this.updateRealMoney(this.realMoney)
  }
}

export default ExtraBonusCalc
</script>

<style lang="scss">
  .calc {
    background: #262626;
    border: none;
    box-sizing: border-box;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 0 32px;
    max-width: 630px;
    @include media_tablet {
      border-radius: 10px;
      border: 1px solid #4D4D4D;
      padding: 24px 7.8% 32px;
    }
    @include media_desktop {
      padding: 24px 3.66% 32px;
    }
    &_heading {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 32px;
      display: flex;
      align-items: center;
      color: #FFFFFF;
      margin-bottom: 5px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      display: flex;
      align-items: center;
      color: #999999;
      margin-bottom: 16px;
    }
    &_games {
      display: grid;
      grid-column-gap: 16px;
      grid-template-columns: 1fr;
      width: 100%;
      margin-bottom: 8px;
      list-style: none;
      @include media_tablet {
        width: auto;
        margin-bottom: 24px;
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
    &_games-item {
      border: 1px solid #4D4D4D;
      box-sizing: border-box;
      border-radius: 10px;
      padding: 16px 15px;
      cursor: pointer;
      margin-bottom: 8px;
      list-style: none;
      @include media_tablet {
        margin-bottom: 0;
      }
      &__active {
        background: linear-gradient(0deg, #808080, #808080), linear-gradient(0deg, #808080, #808080), #333333;
      }
      > img {
        width: 100%;
        max-height: 20px;
        display: block;
      }
    }
    &_inputs {
      width: 100%;
      display: flex;
      flex-direction: column;
      @include media_tablet {
        flex-direction: row;
      }
    }
    &_input-div {
      width: 100%;
      flex: 1;
      position: relative;
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        top: -8px;
        width: 0;
        height: 8px;
        border-top: none;
        border-left: 1px solid #666;
        @include media_tablet {
          top: 50%;
          left: 0;
          width: 100%;
          height: 0;
          border-top: 1px solid #666;
          border-left: none;
        }
      }
    }
    &_slider-place {
      width: 100%;
      margin-top: 16px;
      .vue-slider {
        background: #181818;
        border-radius: 24px;
      }
      .vue-slider-rail {
        margin: 0 auto;
        width: calc(100% - 22px);
        height: 2px;
        background-color: #333333;
      }
      .vue-slider-dot {
        border-radius: 50%;
        transition: background-color .3s ease;
        background-color: var(--selected-game-color);
      }
      .vue-slider-dot-tooltip {
        display: none;
      }
    }
  }
</style>
